(() => {
  if (window.rdbLuxeCrown || !('IntersectionObserver' in window)) return;
  window.rdbLuxeCrown = true;
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const crowns = new Map();
  let suspended = false;
  const update = (button, state) => {
    button.classList.toggle('is-crown-visible', state.visible && button.isConnected && !document.hidden && !suspended && !motion.matches);
  };
  const updateAll = () => crowns.forEach((state, button) => update(button, state));
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const state = crowns.get(entry.target);
      if (!state) return;
      state.visible = entry.isIntersecting && entry.intersectionRatio >= .9;
      update(entry.target, state);
    });
  }, { threshold: [0, .9, 1] });
  const initialize = () => {
    document.querySelectorAll('body.rdb-design-2 .d2-price-categories__luxe').forEach(button => {
      if (crowns.has(button) || !button.querySelector('.d2-luxe-crown__glint')) return;
      const state = { visible: false };
      crowns.set(button, state);
      observer.observe(button);
    });
  };
  document.addEventListener('visibilitychange', updateAll);
  motion.addEventListener('change', updateAll);
  window.addEventListener('pagehide', () => { suspended = true; updateAll(); });
  window.addEventListener('pageshow', () => { suspended = false; updateAll(); });
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', event => {
    crowns.forEach((state, button) => {
      if (!event.target.contains(button)) return;
      observer.unobserve(button);
      button.classList.remove('is-crown-visible');
      crowns.delete(button);
    });
  });
  initialize();
})();
